export function getRenderMentionPopup(mentionsParamsRef) {
    return () => {
        return {
            onStart: (props) => {
                mentionsParamsRef.current?.updatePopupStateSubject.next({
                    isOpen: true,
                    anchorEl: props.clientRect?.() ?? null,
                    onSelect: props.command,
                });
            },
            onUpdate: (props) => {
                mentionsParamsRef.current?.updatePopupStateSubject.next({
                    isOpen: true,
                    anchorEl: props.clientRect?.() ?? null,
                    query: props.query,
                    onSelect: props.command,
                });
            },
            onKeyDown: ({ event }) => {
                if (!mentionsParamsRef.current?.onMentionKeyDownRef.current)
                    return false;
                return mentionsParamsRef.current.onMentionKeyDownRef.current(event);
            },
            onExit: () => {
                mentionsParamsRef.current?.updatePopupStateSubject.next({
                    isOpen: false,
                    anchorEl: null,
                    query: '',
                });
            },
        };
    };
}
